import { isFeatureEnabled } from 'owa-feature-flags';
import type MailListColumnHeaderType from '../types/MailListColumnHeaderType';
import { isReadingPanePositionRight } from '../selectors/readingPanePosition';
import {
    RPRIGHT_RECEIVED_COLUMN_CONTENT_MIN_WIDTH,
    RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH,
    LV_SCROLLBAR_WIDTH,
    LV_RPFULL_RECEIVED_TOTAL_MIN_WIDTH,
    LV_RPRIGHT_RECEIVED_TOTAL_MIN_WIDTH,
} from '../mailLayoutConstants';
export default function getColumnMinWidth(headerType: MailListColumnHeaderType): number {
    const shouldShowColumnHeaderStyles =
        isFeatureEnabled('tri-mlFocusSelect') && isFeatureEnabled('tri-mlColumnHeaderHover');
    const isReadingPaneRight = isReadingPanePositionRight();
    switch (headerType) {
        case 0:
            // minimum sender column width is 2x max iconbar width. min width is also the default width ;
            return 260;
        case 1:
            return 92;
        case 2:
            if (shouldShowColumnHeaderStyles) {
                return getReceivedColumnMinWidth(true /* isColumnHeader */, isReadingPaneRight);
            } else {
                return isReadingPaneRight
                    ? RPRIGHT_RECEIVED_COLUMN_CONTENT_MIN_WIDTH
                    : RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH;
            }
        case 4:
        case 5:
            return 48;
        case 3:
            return 89;
        case 6:
        case 7:
            return 86;
        default:
            return 0;
    }
}

export function getReceivedColumnMinWidth(
    isColumnHeader: boolean,
    isReadingPaneRight: boolean
): number {
    let totalMinWidth = 0;
    if (isReadingPaneRight) {
        totalMinWidth = LV_RPRIGHT_RECEIVED_TOTAL_MIN_WIDTH;
    } else {
        totalMinWidth = LV_RPFULL_RECEIVED_TOTAL_MIN_WIDTH;
    }

    if (isColumnHeader) {
        totalMinWidth += LV_SCROLLBAR_WIDTH;
    }

    return totalMinWidth;
}
